"use client";

import React from "react";
import styles from "./CardList.module.css";
import { Source } from "./types";
import { truncateHash } from "./utils";

interface SourceCardProps {
  source: Source;
  isNew: boolean;
}

const SourceCard: React.FC<SourceCardProps> = ({ source, isNew }) => {
  return (
    <div
      className={styles.card}
      style={{
        opacity: isNew ? 0 : 1,
        animation: isNew ? "fadeIn 0.5s ease-in-out forwards" : undefined,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <div className={styles.cardHeader}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            minWidth: 0,
          }}
        >
          {source.image_content?.logo_url ? (
            <img
              src={source.image_content.logo_url}
              alt={source.image_content.name}
              style={{
                width: "1.5rem",
                height: "1.5rem",
                borderRadius: "0.25rem",
                objectFit: "cover",
                flexShrink: 0,
                background: "#ffffff",
                padding: "1px",
              }}
            />
          ) : (
            <span style={{ fontSize: "1.25rem", flexShrink: 0 }}>📦</span>
          )}
          <a
            href={`https://management.opengpu.network/sources/${source.address}`}
            className={styles.cardTitle}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              flex: 1,
            }}
          >
            {source.image_content?.name || "Unknown"}
          </a>
          {source.status === "Active" && (
            <span
              style={{
                color: "#48bb78",
                fontSize: "0.75rem",
                flexShrink: 0,
              }}
            >
              ✓
            </span>
          )}
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Source</span>
          <a
            href={`https://management.opengpu.network/sources/${source.address}`}
            className={styles.hash}
            target="_blank"
            rel="noopener noreferrer"
          >
            {truncateHash(source.address)}
          </a>
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Providers</span>
          <span className={styles.cardValue}>
            {source.registered_provider_count.toLocaleString()}
          </span>
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Tasks</span>
          <span className={styles.cardValue}>{source.total_task_count.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default SourceCard;
